import { lightTheme } from '@/customTheme'
import { CSSProperties, HTMLAttributes, ReactNode } from 'react'
import { styled } from 'styletron-react'

const GradientTextWrapper = styled('span', (props: { $disabled?: boolean }) => ({
  ...(props.$disabled
    ? {
        color: lightTheme.colors.text.text_200_disable,
      }
    : {
        background: 'linear-gradient(125deg, #FF1866 2.53%, #FD0167 18.16%, #F00188 38.58%, #DD01A0 48.37%, #D203B4 61.09%, #C10EC4 77.43%, #99019C 98.21%)',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      }),
  fontWeight: 600,
}))

interface GradientTextProps extends HTMLAttributes<HTMLSpanElement> {
  style?: CSSProperties
  disabled?: boolean
  children: ReactNode
}

function GradientText({ style, disabled, children, ...rest }: GradientTextProps) {
  return <GradientTextWrapper $disabled={disabled} style={style} {...rest}>{children}</GradientTextWrapper>
}

export default GradientText